export default {
  read: {
    title: "Advisor",
    subtitle:
      "Request a consultancy with your digital advisor to boost your website."
  }
};
